/**
 * Devises supportées : grille tarifaire complète par plan + add-ons.
 * Détection automatique du pays via ipapi.co + localStorage.
 */

// Code pays ISO → devise par défaut
export const PAYS_DEVISE = {
  // Afrique de l'Ouest (Franc CFA XOF)
  CI: "XOF", SN: "XOF", ML: "XOF", BF: "XOF",
  BJ: "XOF", TG: "XOF", NE: "XOF", GN: "XOF",
  // Afrique centrale (Franc CFA XAF)
  CM: "XAF", CG: "XAF", GA: "XAF", CD: "XAF",
  CF: "XAF", TD: "XAF",
  // Amérique du Nord francophone
  CA: "CAD",
  // Suisse
  CH: "CHF",
  // Europe → EUR par défaut (couvert par fallback)
};

export const TARIFS = {
  EUR: {
    symbole: "€", nom: "Euro", drapeau: "🇪🇺", code: "EUR",
    plans: {
      communaute: { mensuel: 14.99, annuel: 161.89 },
      starter:    { mensuel: 29.99, annuel: 323.89 },
      pro:        { mensuel: 79.99, annuel: 863.89 },
      enterprise: { mensuel: 199.99, annuel: 2159.89 },
    },
    addons: {
      page_publique:       { mensuel: 7,  annuel: 76 },
      dons_recurrents:     { mensuel: 7,  annuel: 76 },
      suivi_contributions: { mensuel: 5,  annuel: 54 },
      qr_presences:        { mensuel: 5,  annuel: 54 },
      sms_notifications:   { mensuel: 9,  annuel: 97 },
      rapports_avances:    { mensuel: 7,  annuel: 76 },
      parcours_discipulat: { mensuel: 5,  annuel: 54 },
    },
  },
  XOF: {
    symbole: "FCFA", nom: "Franc CFA Ouest", drapeau: "🌍", code: "XOF",
    plans: {
      communaute: { mensuel: 9900,   annuel: 106920 },
      starter:    { mensuel: 19900,  annuel: 214920 },
      pro:        { mensuel: 52900,  annuel: 571320 },
      enterprise: { mensuel: 129900, annuel: 1402920 },
    },
    addons: {
      page_publique:       { mensuel: 4590, annuel: 49572 },
      dons_recurrents:     { mensuel: 4590, annuel: 49572 },
      suivi_contributions: { mensuel: 3280, annuel: 35424 },
      qr_presences:        { mensuel: 3280, annuel: 35424 },
      sms_notifications:   { mensuel: 5900, annuel: 63720 },
      rapports_avances:    { mensuel: 4590, annuel: 49572 },
      parcours_discipulat: { mensuel: 3280, annuel: 35424 },
    },
  },
  XAF: {
    symbole: "FCFA", nom: "Franc CFA Central", drapeau: "🌍", code: "XAF",
    plans: {
      communaute: { mensuel: 9900,   annuel: 106920 },
      starter:    { mensuel: 19900,  annuel: 214920 },
      pro:        { mensuel: 52900,  annuel: 571320 },
      enterprise: { mensuel: 129900, annuel: 1402920 },
    },
    addons: {
      page_publique:       { mensuel: 4590, annuel: 49572 },
      dons_recurrents:     { mensuel: 4590, annuel: 49572 },
      suivi_contributions: { mensuel: 3280, annuel: 35424 },
      qr_presences:        { mensuel: 3280, annuel: 35424 },
      sms_notifications:   { mensuel: 5900, annuel: 63720 },
      rapports_avances:    { mensuel: 4590, annuel: 49572 },
      parcours_discipulat: { mensuel: 3280, annuel: 35424 },
    },
  },
  CAD: {
    symbole: "CA$", nom: "Dollar canadien", drapeau: "🇨🇦", code: "CAD",
    plans: {
      communaute: { mensuel: 19.99,  annuel: 215.89 },
      starter:    { mensuel: 39.99,  annuel: 431.89 },
      pro:        { mensuel: 99.99,  annuel: 1079.89 },
      enterprise: { mensuel: 249.99, annuel: 2699.89 },
    },
    addons: {
      page_publique:       { mensuel: 9.99,  annuel: 107.89 },
      dons_recurrents:     { mensuel: 9.99,  annuel: 107.89 },
      suivi_contributions: { mensuel: 6.99,  annuel: 75.49 },
      qr_presences:        { mensuel: 6.99,  annuel: 75.49 },
      sms_notifications:   { mensuel: 11.99, annuel: 129.49 },
      rapports_avances:    { mensuel: 9.99,  annuel: 107.89 },
      parcours_discipulat: { mensuel: 6.99,  annuel: 75.49 },
    },
  },
  CHF: {
    symbole: "CHF", nom: "Franc suisse", drapeau: "🇨🇭", code: "CHF",
    plans: {
      communaute: { mensuel: 13.99,  annuel: 150.89 },
      starter:    { mensuel: 27.99,  annuel: 302.89 },
      pro:        { mensuel: 74.99,  annuel: 809.89 },
      enterprise: { mensuel: 189.99, annuel: 2051.89 },
    },
    addons: {
      page_publique:       { mensuel: 6.50, annuel: 70.20 },
      dons_recurrents:     { mensuel: 6.50, annuel: 70.20 },
      suivi_contributions: { mensuel: 4.50, annuel: 48.60 },
      qr_presences:        { mensuel: 4.50, annuel: 48.60 },
      sms_notifications:   { mensuel: 8.50, annuel: 91.80 },
      rapports_avances:    { mensuel: 6.50, annuel: 70.20 },
      parcours_discipulat: { mensuel: 4.50, annuel: 48.60 },
    },
  },
};

export const DEVISES_LIST = Object.keys(TARIFS);

/** Formate un montant numérique selon la devise. */
export function formatPrix(montant, devise) {
  if (montant == null) return "—";
  if (devise === "XOF" || devise === "XAF") {
    return `${Math.round(montant).toLocaleString("fr-FR")} FCFA`;
  }
  const d = TARIFS[devise];
  return `${montant.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${d?.symbole || "€"}`;
}

/** Renvoie true si la devise correspond à un pays d'Afrique (FCFA). */
export function isAfricanDevise(devise) {
  return devise === "XOF" || devise === "XAF";
}
